export default "<router-outlet>\r\n  <app-shared></app-shared>\r\n</router-outlet>\r\n"